var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLinesHorizontal = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 15.7071C-0.0976311 15.3166 -0.0976311 14.6834 0.292893 14.2929L4.29289 10.2929C4.68342 9.90237 5.31658 9.90237 5.70711 10.2929C6.09763 10.6834 6.09763 11.3166 5.70711 11.7071L3.41421 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H3.41421L5.70711 18.2929C6.09763 18.6834 6.09763 19.3166 5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071L0.292893 15.7071ZM14.5858 6L1 6C0.447715 6 1.49012e-08 5.55229 1.49012e-08 5C1.49012e-08 4.44771 0.447715 4 1 4L14.5858 4L12.2929 1.70711C11.9024 1.31658 11.9024 0.683418 12.2929 0.292892C12.6834 -0.0976315 13.3166 -0.0976315 13.7071 0.292892L17.7071 4.29289C18.0976 4.68342 18.0976 5.31658 17.7071 5.70711L13.7071 9.70711C13.3166 10.0976 12.6834 10.0976 12.2929 9.70711C11.9024 9.31658 11.9024 8.68342 12.2929 8.29289L14.5858 6Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLinesHorizontal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowLinesHorizontal.47e1b6012e391caaf299b7ee321be98d.svg";